module.exports = __webpack_public_path__ + "img/team-08.1512b183.jpg";